<template>
  <div class="performance-right-chart-container">
    <div>
      当前
      <div :id="currentChartId" class="performance-chart"></div>
    </div>
    <div style="margin-top: 1px">
      同比
      <div :id="compareChartId" class="performance-chart"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Chart } from '@antv/g2'
import { getSiteMonitorHistory } from '@/api/site'
import { humanizeValue } from '@/utils'

const chartTop = {}
const chartBottom = {}

export default {
  name: 'PerformanceRightChart',
  props: {
    site: {
      type: Object
    },
    serviceId: {
      type: String
    },
    currentChartId: {
      type: String
    },
    compareChartId: {
      type: String
    }
  },
  data () {
    return {
      currentDate: [moment().subtract(0.5, 'hour'), moment()],
      compareDate: [moment().subtract(24.5, 'hour'), moment().subtract(24, 'hour')],
      lastWeekDate: [moment().subtract(6, 'day').subtract(0.5, 'hour'), moment().subtract(6, 'day')],
      currentData: [],
      compareData: []
    }
  },
  mounted () {
    this.fetch()
    this.initTop()
    this.initBottom()
  },
  methods: {
    fetch () {
      getSiteMonitorHistory(this.site.id, {
        key: `log.nginx[${this.site.url},requests]`,
        datetime_from: this.currentDate[0].format('YYYY-MM-DD HH:mm'),
        datetime_to: this.currentDate[1].format('YYYY-MM-DD HH:mm')
      }).then(res => {
        const data = res.data
        this.currentData = data.data || []

        if (data.total) {
          getSiteMonitorHistory(this.site.id, {
            key: `log.nginx[${this.site.url},requests]`,
            datetime_from: this.lastWeekDate[0].format('YYYY-MM-DD HH:mm'),
            datetime_to: this.lastWeekDate[1].format('YYYY-MM-DD HH:mm')
          }).then(res => {
            const data = res.data
            const a = this.currentData[this.currentData.length - 1].value * 1 || 0
            let b = 0
            if (data.total) b = data.data[data.data.length - 1].value * 1 || 0
            let rate = 0
            if (b !== 0) rate = parseInt((a - b) / b * 100)

            this.$emit('rate', rate)
          })
        }
      })
      getSiteMonitorHistory(this.site.id, {
        key: `log.nginx[${this.site.url},requests]`,
        datetime_from: this.compareDate[0].format('YYYY-MM-DD HH:mm'),
        datetime_to: this.compareDate[1].format('YYYY-MM-DD HH:mm')
      }).then(res => {
        const data = res.data
        this.compareData = data.data || []
      })
    },
    initTop () {
      chartTop[this.currentChartId] = new Chart({
        container: this.currentChartId,
        autoFit: true,
        appendPadding: [12, 6, 0, 0]
      })
      chartTop[this.currentChartId].axis(false)
      chartTop[this.currentChartId].scale({
        timestamp: {
          type: 'time',
          mask: 'MM-DD HH:mm'
        },
        value: {
          min: 0,
          nice: true,
          alias: '值',
          formatter: value => humanizeValue(value)
        }
      })
      chartTop[this.currentChartId]
        .line()
        .position('timestamp*value')
        .color('#195EFF')
      chartTop[this.currentChartId].render()
    },
    renderCurrent () {
      if (this.currentData.length === 0) {
        chartTop[this.currentChartId].changeVisible(false)
      } else {
        let max = this.currentData[0]
        for (const datum of this.currentData) {
          if (datum.value > max.value) max = datum
        }
        chartTop[this.currentChartId].annotation().dataMarker({
          point: {
            style: {
              stroke: '#195EFF'
            }
          },
          line: {
            length: 0
          },
          top: true,
          position: [max.timestamp, max.value],
          text: {
            content: `峰值: ${humanizeValue(max.value)}`
          }
        })
        chartTop[this.currentChartId].changeData(this.currentData)
        chartTop[this.currentChartId].changeVisible(true)
      }
    },
    initBottom () {
      chartBottom[this.compareChartId] = new Chart({
        container: this.compareChartId,
        autoFit: true,
        appendPadding: [12, 6, 0, 0]
      })
      chartBottom[this.compareChartId].axis(false)
      chartBottom[this.compareChartId].scale({
        timestamp: {
          type: 'time',
          mask: 'MM-DD HH:mm'
        },
        value: {
          min: 0,
          nice: true,
          alias: '值',
          formatter: value => humanizeValue(value)
        }
      })
      chartBottom[this.compareChartId]
        .line()
        .position('timestamp*value')
        .color('#52C41A')
      chartBottom[this.compareChartId].render()
    },
    renderCompare () {
      if (this.compareData.length === 0) {
        chartBottom[this.compareChartId].changeVisible(false)
      } else {
        let max = this.compareData[0]
        for (const datum of this.compareData) {
          if (datum.value > max.value) max = datum
        }
        chartBottom[this.compareChartId].annotation().dataMarker({
          point: {
            style: {
              stroke: '#52C41A'
            }
          },
          top: true,
          line: {
            length: 0
          },
          position: [max.timestamp, max.value],
          text: {
            content: `峰值: ${humanizeValue(max.value)}`
          }
        })
        chartBottom[this.compareChartId].changeData(this.compareData)
        chartBottom[this.compareChartId].changeVisible(true)
      }
    }
  },
  watch: {
    currentData () {
      this.renderCurrent()
    },
    compareData () {
      this.renderCompare()
    }
  }
}
</script>

<style lang="less" scoped>
.performance-right-chart-container {
  height: 170px;
  margin-top: 12px;

  .performance-chart{
    height: 60px;
    display: inline-block;
    margin-left: 12px;
    width: calc(100% - 44px);
  }
}
</style>
